/* eslint-disable no-restricted-syntax */
const mediaBreakPoint = '(min-width: 768px)';
const mq = window.matchMedia(mediaBreakPoint);
const servicesTables = document.querySelectorAll('.js-services-table');
let showMobileOnlyElems = false;
let showDesktopOnlyElems = true;

function toggleServicesMobileOnly(show) {
	let mobileOnlyElems = [];
	for (const tt of servicesTables) {
		mobileOnlyElems = [...mobileOnlyElems, ...tt.querySelectorAll('.mobile-only')];
	}
	showMobileOnlyElems = show;

	for (const elem of mobileOnlyElems) {
		if (show) {
			elem.setAttribute('aria-hidden', false);
			elem.removeAttribute('hidden');
		} else {
			elem.setAttribute('aria-hidden', true);
			elem.setAttribute('hidden', '');
		}
	}
}

function toggleServicesDesktopOnly(show) {
	let desktopOnlyElems = [];
	for (const tt of servicesTables) {
		desktopOnlyElems = [...desktopOnlyElems, ...tt.querySelectorAll('.desktop-only')];
	}
	showDesktopOnlyElems = show;

	for (const elem of desktopOnlyElems) {
		if (show) {
			elem.setAttribute('aria-hidden', false);
			elem.removeAttribute('hidden');
		} else {
			elem.setAttribute('aria-hidden', true);
			elem.setAttribute('hidden', '');
		}
	}
}

if (servicesTables.length) {
	toggleServicesMobileOnly(!mq.matches);
	toggleServicesDesktopOnly(mq.matches);
}

window.addEventListener('resize', function () {
	if (servicesTables.length) {
		if (mq.matches && showMobileOnlyElems) {
			toggleServicesMobileOnly(false);
		} else if (!mq.matches && !showMobileOnlyElems) {
			toggleServicesMobileOnly(true);
		}

		if (mq.matches && !showDesktopOnlyElems) {
			toggleServicesDesktopOnly(true);
		} else if (!mq.matches && showDesktopOnlyElems) {
			toggleServicesDesktopOnly(false);
		}
	}
});

const tableEls = document.querySelectorAll('.text-rte table');
if (tableEls.length) {
	tableEls.forEach((tableEl) => {
		const tableWrapEl = document.createElement('div');
		tableWrapEl.classList.add('table-wrapper');
		tableEl.parentNode.insertBefore(tableWrapEl, tableEl);
		tableWrapEl.appendChild(tableEl);
		// tableWrapEl.parentNode.removeChild(tableEl);
	});
}
